import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = Schema.attributes;

const VerstetigungAusblickAbschlussKreativ: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title='Verstetigung und Ausblick' description={PLATZHALTER_TEXT} />
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};
export default VerstetigungAusblickAbschlussKreativ;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Abschlussbericht_Kreativwirtschaft.schema.attributes.Abschlussbericht_Kreativ_0241031524_rhaben_Zurueckzufuehren_Sind,
				P.Abschlussbericht_Kreativwirtschaft.schema.attributes.Abschlussbericht_Kreativ_0122758951_r_Vorstellbaren_Finanzierung,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucVerstetigungAusblickAbschlussKreativ = () => {
	return concat(formStruc());
};
